import { URL_ROUTES } from '@/constants';
import { Link } from '@/modules/perseo-billing/components';

export const Terms = () => {
  const parisLinkLabel = 'Términos y Condiciones de Paris';
  const marketlpaceLinkLabel = 'Términos y Condiciones de Marketplace';
  const privacyPolicyLinkLabel = 'Políticas de Privacidad de Datos.';

  return (
    <p className="co-font-montserrat co-font-medium co-text-common-grey">
      Acepto{' '}
      <Link href={URL_ROUTES.PARIS_TERMS_LINK} target="_blank">
        {parisLinkLabel}
      </Link>
      ,{' '}
      <Link href={URL_ROUTES.MARKETPLACE_TERMS_LINK} target="_blank">
        {marketlpaceLinkLabel}
      </Link>{' '}
      y las{' '}
      <Link href={URL_ROUTES.PRIVACY_POLICY_LINK} target="_blank">
        {privacyPolicyLinkLabel}
      </Link>
    </p>
  );
};
